import Vue from 'vue'
import App from './index.vue'
import promise from 'es6-promise';
promise.polyfill();
import api from '@/api/index'

// vue-提示组件
import { Message } from 'element-ui';
import { MessageBox } from 'element-ui';
// 系统使用ie低版本提示
import 'babel-polyfill';
if(navigator.appName == "Microsoft Internet Explorer"&&parseInt(navigator.appVersion.split(";")[1].replace(/[ ]/g, "").replace("MSIE",""))<9){
    MessageBox.alert('您的浏览器版本过低，请使用IE9及以上版本！', '系统提示', {
        confirmButtonText: '确定',
        callback: action => {
            Message({
                message: '您的浏览器版本过低，请使用IE9及以上版本！',
                type: 'warning',
                duration:10000
            })
        }
    });
    // Message.warning({ title: '', message: '您的浏览器版本过低，请使用IE10及以上版本！'});
}

// 引入公共样式
import '@/stylesheets/main.scss';
import 'element-ui/lib/theme-chalk/index.css';
// 公用方法
import message from "@/util/message";
Vue.use(message);
// api共用接口js
Vue.prototype.$api = api;
Vue.config.productionTip = false
Vue.prototype.$message = Message;

new Vue({
    render: h => h(App),
}).$mount('#app')
